"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var deprecatedIcons = ['threstles', 'threstle', 'arrow-right', 'arrow-left', 'arrow_down', 'arrow_up', 'select-all_2', 'chair_bar', 'chair_long', 'storage_accessories', 'extractor_hood', 'landscape_to_portrait'].map(function (iconName) {
  return 'IKEA--icon-' + iconName;
});
/**
 * StyleUtility
 */

var StyleUtility = /*#__PURE__*/function () {
  function StyleUtility() {
    _classCallCheck(this, StyleUtility);
  }

  _createClass(StyleUtility, null, [{
    key: "getIconClasses",

    /**
     * Gets all IKEA icons css classes.
     *
     * @returns {Array} - IKEA icons css classes.
     */
    value: function getIconClasses() {
      var icons = [];
      var sheet = document.styleSheets;
      var rule = null,
          i = sheet.length,
          j;

      while (0 <= --i) {
        try {
          rule = sheet[i].rules || sheet[i].cssRules || [];
        } catch (error) {
          rule = [];
        }

        j = rule.length;

        while (0 <= --j) {
          if (rule[j].constructor === CSSStyleRule && rule[j].selectorText.includes('.IKEA--icon')) {
            var selectorText = rule[j].selectorText.match(/(.ikea--icon-.*)::before/gi);

            if (selectorText) {
              var icon = selectorText[0].replace('::before', '').replace('.', '');

              if (!icons.includes(icon) && !deprecatedIcons.includes(icon)) {
                icons.push(icon);
              }
            }
          }
        }
      }

      return icons.sort();
    }
    /**
     * Get Icons names.
     *
     * @returns {Array} - IKEA icons names.
     */

  }, {
    key: "getIconNames",
    value: function getIconNames() {
      return this.getIconClasses().map(function (value) {
        return value.replace('IKEA--icon-', '');
      });
    }
  }]);

  return StyleUtility;
}();

exports.default = StyleUtility;